import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import getSize from "viewport-size";
import { MdWarning } from "react-icons/md";

import { Context } from "../context/context";
import EventImage from "../assets/images/event-image.png";

const Finance = () => {
  let history = useHistory();
  const {
    state: {
      data: { details, finance },
    },
    dispatch,
  } = useContext(Context);

  const [detailsFields, setDetailsFields] = useState(JSON.parse(localStorage.getItem("details")) || details);
  const [financeFields, setFinanceFields] = useState(JSON.parse(localStorage.getItem("finance")) || finance);
  const [mandatoryFields, setMandatoryFields] = useState({ budgets: false, deposit: false, mileages: false });
  const [showErrors, setShowErrors] = useState(false);

  const navigateNext = (slug) => {
    const { budgets, deposit, mileages } = mandatoryFields;
    if (budgets && deposit && mileages) {
      // Set the layout to completed and then
      dispatch({ type: "SET_LAYOUT_VISITED", slug: "finance" });
      history.push(slug);
    } else {
      //set page error  to true
      setShowErrors(true);
    }
  };

  const navigateBack = (slug) => {
    // First set the layout to completed and then
    // dispatch({ type: "SET_LAYOUT_VISITED", slug: "welcome" });
    history.push(slug);
  };

  const updateBudgets = (title) => {
    dispatch({ type: "UPDATE_FINANCE_BUDGET", title: title });
  };

  const updateMileages = (title) => {
    dispatch({ type: "UPDATE_FINANCE_MILEAGE", title: title });
  };

  const updateDeposit = (event) => {
    dispatch({ type: "UPDATE_FINANCE_DEPOSIT", data: event.target.value });
  };

  // This useEffect will run on first load to check what is in localstorage and populate our context with it
  useEffect(() => {
    const details = localStorage.getItem("details");
    const finance = localStorage.getItem("finance");

    if (details) {
      dispatch({ type: "UPDATE_ALL_DETAILS", data: JSON.parse(details) });
      setDetailsFields(details);
    }

    if (finance) {
      dispatch({ type: "UPDATE_ALL_FINANCES", data: JSON.parse(finance) });
      setFinanceFields(finance);
    }

    // Scroll to top on mobile screens only page load
    if (getSize.getWidth() < 575) {
      try {
        // trying to use new API - https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollTo
        window.scroll({
          top: 420,
          left: 0,
          behavior: "smooth",
        });
      } catch (error) {
        // just a fallback for older browsers
        window.scrollTo(0, 0);
      }
    } else {
      try {
        // trying to use new API - https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollTo
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      } catch (error) {
        // just a fallback for older browsers
        window.scrollTo(0, 0);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // This useEffect will set the data into localstorage on selection change
  useEffect(() => {
    const { budgets, deposit, mileages } = mandatoryFields;

    setDetailsFields(details);
    localStorage.setItem("details", JSON.stringify(details));

    setFinanceFields(finance);
    localStorage.setItem("finance", JSON.stringify(finance));

    if (budgets && deposit && mileages) {
      // Set the layout to completed and then
      setShowErrors(false);
    }
  }, [details, finance, mandatoryFields]);

  // This useEffect will check whether any of the fields has been selected and set the button visibility
  useEffect(() => {
    const budgetIsEntered = financeFields.budgets.some((element) => {
      return element.selected === true;
    });
    const depositIsEntered = () => {
      if (financeFields.deposit.length === 0) {
        return false;
      } else {
        return true;
      }
    };

    const mileageIsEntered = financeFields.mileages.some((element) => {
      return element.selected === true;
    });

    setMandatoryFields((prevState) => {
      return { ...prevState, budgets: budgetIsEntered, deposit: depositIsEntered(), mileages: mileageIsEntered };
    });
  }, [financeFields]);

  return (
    <div className="card border-0 mb-5 my-md-0 mb-0 mb-md-5">
      <div className="card-body">
        <div className="row align-items-center justify-content-center">
          <div className="col-12 col-md-8 order-2 order-md-1 text-center text-md-left my-4 my-md-0">
            <h1 className="page-title mb-0">Finance options</h1>
          </div>
          <div className="col-8 col-md-4 order-1 order-md-2">
            <img className="img-fluid" alt="event logo" src={EventImage} />
          </div>
        </div>
        <div className="row text-center text-md-left justify-content-center justify-content-md-start mt-3">
          <div className="col-12 mb-3">
            <h3 className="page-sub-title">Choose your monthly budget</h3>
          </div>

          <div className="col-12 col-lg-6">
            <div className="row">
              <div className="col-12">
                <div className="row">
                  {financeFields.budgets.map((budget) => {
                    return (
                      <div className="col-12 col-md-4 col-lg-3" key={budget.title}>
                        <div className="radio mx-auto">
                          <label>
                            <input
                              onClick={() => {
                                updateBudgets(budget.title);
                              }}
                              type="radio"
                              name="budget"
                              value={budget.value}
                              defaultChecked={budget.selected}
                            />
                            {budget.title}
                            <span className="checkmark" />
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              {showErrors && !mandatoryFields.budgets && (
                <div className="col-12">
                  <div className="alert alert-danger mt-1" role="alert">
                    <MdWarning className="mi-18" /> Monthly budget is required
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row text-center text-md-left justify-content-center justify-content-md-start mt-5">
          <div className="col-12 mb-3">
            <h3 className="page-sub-title"> How much deposit would you like to put down?</h3>
          </div>

          <div className="col-12 col-lg-6 my-2">
            <div className="row justify-content-center justify-content-md-start">
              <div className="col-12 col-sm-7 col-md-5 col-lg-6">
                <div className="input-currency">
                  <input
                    type="number"
                    className="form-control"
                    defaultValue={financeFields.deposit}
                    name="deposit"
                    onChange={(event) => {
                      updateDeposit(event);
                    }}
                  />
                  <div className="font-weight-500">£</div>
                </div>
              </div>
              {showErrors && !mandatoryFields.deposit && (
                <div className="col-12">
                  <div className="alert alert-danger mt-1" role="alert">
                    <MdWarning className="mi-18" /> Deposit amount is required
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row text-center text-md-left justify-content-center justify-content-md-start mt-5">
          <div className="col-12 mb-3">
            <h3 className="page-sub-title">My average annual mileage</h3>
          </div>

          <div className="col-12 col-lg-6">
            <div className="row">
              <div className="col-12">
                <div className="row">
                  {financeFields.mileages.map((mileage) => {
                    return (
                      <div className="col-12 col-md-4 col-lg-3" key={mileage.title}>
                        <div className="radio mx-auto">
                          <label>
                            <input
                              onClick={() => {
                                updateMileages(mileage.title);
                              }}
                              type="radio"
                              name="mileage"
                              value={mileage.value}
                              defaultChecked={mileage.selected}
                            />
                            {mileage.title}
                            <span className="checkmark" />
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              {showErrors && !mandatoryFields.mileages && (
                <div className="col-12">
                  <div className="alert alert-danger mt-1" role="alert">
                    <MdWarning className="mi-18" /> Average mileage is required
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {showErrors && (
          <div className="row text-center text-md-left mt-5 mb-n5">
            <div className="col-12 col-lg-6">
              <div className="alert alert-danger" role="alert">
                <MdWarning className="mi-18" /> You must complete all mandatory fields above to continue
              </div>
            </div>
          </div>
        )}

        <div className="row text-center text-md-left mt-5 ">
          <div className="col-12 col-md-6 col-lg-4">
            <div className="row">
              <div className="col-6">
                <div className="btn btn-primary" onClick={() => navigateBack("selection")}>
                  Back
                </div>
              </div>
              <div className="col-6">
                {mandatoryFields && (
                  <div className="btn btn-primary" onClick={() => navigateNext("part-exchange")}>
                    Next
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Finance;
